import { AttendeesList, IOptionsWithTypes } from "@eventr/common";
import { useMemo } from "react";
import { routes } from "routing";
import { useScreenTypeContext } from "../../state/screenTypeProvider";
import { FlightAttachments } from "../flightComponents/flightAttachments";
import { FlightPassengers } from "../flightComponents/flightPassengers";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";
import { EditButton } from "../subComponents/editButton";
import { ExpandableSection } from "../subComponents/expendableSection";

import { Stack } from "@mui/material";
import { cardTranslation } from "i18n/translateHelpers";
import i18n from "i18n/i18next";
interface ITodoBookingInfoProps {
  attendess?: AttendeesList[];
  attachments?: { notes?: string; extra_docs?: string };
  attendee?: AttendeesList;
}
export const TodoBookingInfo = ({ attendess, attachments, attendee }: ITodoBookingInfoProps) => {
  const { screenType } = useScreenTypeContext();
  const { _id } = useObjectContext();

  const allAttendess = useMemo(() => {
    const all: IOptionsWithTypes[] = [];
    attendess?.forEach((a) => {
      all.push(...(a.users ?? []));
    });
    return all;
  }, [attendess]);

  const end = useMemo(() => {
    if (screenType === "edit") return <EditButton path={routes.edit.todoItem.build({ itemId: _id })} />;

    return null;
  }, [screenType, _id]);

  if (
    !allAttendess.length &&
    !attachments?.notes &&
    (!attachments?.extra_docs || attachments?.extra_docs.length === 0) &&
    !attendee?.documents &&
    !attendee?.notes
  )
    return (
      <Stack direction="row" sx={{
        justifyContent: "flex-end"
      }}>
        {end}
      </Stack>
    );
  return (
    <ExpandableSection mid={<CardText>{cardTranslation("Additional Information")}</CardText>} end={end}>
      <>
        {attachments && <FlightAttachments notes={attachments.notes} extra_docs={attachments.extra_docs} />}

        {allAttendess.length > 0 && (
          <FlightPassengers passengers={allAttendess} title={i18n.t("edit-itinerary.headers.members")} />
        )}
      </>
    </ExpandableSection>
  );
};
